'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendDefaults = extendDefaults;
exports.formToJSON = formToJSON;
exports.serialize = serialize;
exports.on = on;
exports.getSiblings = getSiblings;
exports.render = render;
exports.isDesktop = isDesktop;
exports.isMediumUp = isMediumUp;
exports.getBrowser = getBrowser;

var _breakpoints = require('../helpers/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Combine two objects using properties as the override.
 * @param {object} defaults - Defaults options defined in script.
 * @param {object} properties - Options defined by user.
 * @return {object} - Defaults modified options.
 */
function extendDefaults(defaults, properties) {
  for (var property in properties) {
    if (properties != null && typeof properties !== 'undefined') {
      defaults[property] = properties[property];
    }
  }

  return defaults;
}

/**
  * Retrieves input data from a form.
  * @param {HTMLForm} form - HTML form elements.
  * @returns {Object} - Form data as an object literal.
  */
/**
 * Helper: Utils
 * ------------------------------------------------------------------------------
 * Frame utility functions.
 *
 * @namespace utils
 */
function formToJSON(elements) {
  return [].reduce.call(elements, function (data, element) {
    if (element.name && element.value) {
      data[element.name] = element.value;
    }
    return data;
  }, {});
}

/**
 * Serialize all form data into a query string.
 * @param {Node} form - The form to serialize.
 * @return {String} - The serialized form data.
 */
function serialize(form) {
  var serialized = [];

  /**
   * Loop through each field in the form.
   */
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
      continue;
    }

    /**
     * If a multi-select, get all selections.
     */
    if (field.type === 'select-multiple') {
      for (var counter = 0; counter < field.options.length; counter++) {
        if (!field.options[counter].selected) {
          continue;
        }

        serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[counter].value));
      }
    } else if (field.type !== 'checkbox' && field.type !== 'radio' || field.checked) {
      serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');
}

/**
 * Shortcut function to add an event listener.
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {String} event -The event type.
 * @param {Node} elem - The element to attach the event to (optional, defaults to window).
 * @param {Function} callback - The callback to run on the event.
 * @param {Boolean} capture - If true, forces bubbling on non-bubbling events.
 */
function on(event) {
  var elem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var callback = arguments[2];
  var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


  /**
   * If only a string is passed into the element parameter.
   */
  if (typeof elem === 'string') {
    document.querySelector(elem).addEventListener(event, callback, capture);
    return;
  }

  /**
   * If an element is not defined in parameters, then shift callback across.
   */
  if (typeof elem === 'function') {
    window.addEventListener(event, elem);
    return;
  }

  /**
   * Default listener.
   */
  elem.addEventListener(event, callback, capture);
}

/**
 * Get all siblings of an element.
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param {Node} elem - The element you want get the siblings of.
 * @return {Array} - The siblings.
 */
function getSiblings(elem) {
  return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
    return sibling !== elem;
  });
}

/**
 * Render function.
 * @param {String} template - The template string to render.
 * @param {Node} node - The node to render into.
 */
function render(template, node) {
  if (!node) {
    return;
  }

  node.innerHTML = template;
}

/**
 * Check if width is dektop up
 */
function isDesktop(template, node) {
  var mediaQuery = {
    desktopUp: '(min-width: ' + _breakpoints2.default.large + ')'
  };

  return window.matchMedia(mediaQuery.desktopUp).matches;
}

/**
 * Check if width is dektop up
 */
function isMediumUp(template, node) {
  var mediaQuery = {
    desktopUp: '(min-width: ' + _breakpoints2.default.medium + ')'
  };

  return window.matchMedia(mediaQuery.desktopUp).matches;
}

/**
 * Browser detect and return a string
 * - https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
 * @returns {String} browser string.
 */
function getBrowser() {
  var userAgent = window.navigator.userAgent;

  // The order matters here, and this may report false positives for unlisted browsers.
  if (userAgent.indexOf('Firefox') > -1) {
    // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
    return 'Firefox';
  } else if (userAgent.indexOf('Opera') > -1) {
    return 'Opera';
  } else if (userAgent.indexOf('Trident') > -1) {
    // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
    return 'Internet Explorer';
  } else if (userAgent.indexOf('Edge') > -1) {
    // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
    return 'Edge';
  } else if (userAgent.indexOf('Chrome') > -1) {
    // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
    return 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
    return 'Safari';
  }

  return 'unknown';
}